export const headerLinks = {
	"links": [
		{
			"link": "/",
			"label": "home"
		},
		{
			"link": "/about",
			"label": "about"
		},
		{
			"link": "/portfolio",
			"label": "portfolio"
		},
		{
			"link": "/contact",
			"label": "get in touch"
		},
	]
}
